import { middlewareCall } from 'services/apiConfig';
import { createLog } from 'services/logService';
import { loadState } from 'utils/localStorage';

export const sendEvent = async (eventName, properties = {}) => {
  const state = loadState();
  const email =
    state?.subscriptionLead?.email ||
    state?.lead?.email ||
    state?.offerLead?.email;
  try {
    const response = await middlewareCall.post(`events`, {
      eventName,
      properties: { ...properties, email },
    });

    return response.data;
  } catch (error) {
    return createLog(error);
  }
};
